import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ConsultationCategoryDataService} from './impl/service/ngrx/consultationCategoryData.service';
import {ConsultationCategoryRepository} from './impl/service/ngrx/consultationCategory.repository';
import {
    AgendaCategoryHolderServiceRegister,
    AgendaCategoryHolderServiceType
} from '../../../agenda/modules/category/api/service/register/agendaCategoryHolderService.registrer';
import {ConsultationCategoryFindAllSummaryService} from './api/service/consultationCategoryFindAllSummary.service';
import {AgendaContext} from '../../../agenda/modules/event/api/entity/agendaEvent.model';

@NgModule({
})
export class ConsultationCategoryModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ConsultationCategoryDataService,
                repository: ConsultationCategoryRepository,
                agendaCategoryHolderServiceRegister: AgendaCategoryHolderServiceRegister
    ) {

        entityDataService.registerServices({
            ConsultationCategory: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ConsultationCategory: repository,
        });

        agendaCategoryHolderServiceRegister.register(ConsultationCategoryFindAllSummaryService,
            AgendaContext.MEDICAL,
            AgendaCategoryHolderServiceType.FIND_ALL);
    }
}
